import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ShareIcon } from 'site-modules/shared/components/social-media/share-icon/share-icon';

const socialBrands = ['facebook', 'twitter', 'linkedin', 'email'];
const ICON_WIDTH = { minWidth: '20px' };

export function Share({ title, url, shareLabel, containerClassName, labelClassName, iconClassName, rssLink }) {
  if (!title || !url) {
    return null;
  }

  return (
    <span className={classnames('share-container text-gray-dark', containerClassName)}>
      <span className={classnames('share', labelClassName)}>{shareLabel}</span>
      <ul className="list-unstyled d-inline-block" aria-label="Share options">
        {socialBrands.map(brand => (
          <li key={brand} className="d-inline-block">
            <ShareIcon
              style={ICON_WIDTH}
              brand={brand}
              title={title}
              url={url}
              className={iconClassName}
              data-tracking-value={brand}
              data-tracking-id="social_share_clickout"
            />
          </li>
        ))}
        {!!rssLink && (
          <li key="rss" className="d-inline-block">
            <ShareIcon
              style={ICON_WIDTH}
              brand="rss"
              title={title}
              url={rssLink}
              className={iconClassName}
              data-tracking-value="rss"
              data-tracking-id="social_share_clickout"
            />
          </li>
        )}
      </ul>
    </span>
  );
}

Share.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  shareLabel: PropTypes.string,
  rssLink: PropTypes.string,
};

Share.defaultProps = {
  title: null,
  url: null,
  containerClassName: 'small',
  labelClassName: 'pe-0_5 hidden-md-down',
  iconClassName: 'px-0_5',
  shareLabel: 'Share:',
  rssLink: '',
};
